import React from "react";
import { Route } from "react-router-dom";
import SuperAdminLayout from "@/super_admin/SuperAdminLayout";
import SuperAdminLogin from "@/super_admin/SuperAdminLogin";
import SuperAdminOverview from "@/super_admin/SuperAdminOverview";
import TenantsList from "@/super_admin/TenantsList";
import PlansManager from "@/super_admin/PlansManager";
import PlanFeatureMatrix from "@/super_admin/PlanFeatureMatrix";
import CatalogManager from "@/super_admin/CatalogManager";
import TransactionsList from "@/super_admin/TransactionsList";
import ClientTransactionsList from "@/super_admin/ClientTransactionsList";
import ActivityLog from "@/super_admin/ActivityLog";
import FinanceDashboard from "@/super_admin/FinanceDashboard";
import PlatformSettings from "@/super_admin/PlatformSettings";
import TeamManager from "@/super_admin/TeamManager";
import AuditLogs from "@/super_admin/AuditLogs";
import Tenant360 from "@/super_admin/Tenant360";
import GlobalDataView from "@/super_admin/GlobalDataView";
import GlobalLearnTelehealth from "@/super_admin/GlobalLearnTelehealth";
import IntegrationsEditor from "@/super_admin/IntegrationsEditor";
import HqCustomers from "@/super_admin/HqCustomers";
import HqServiceLeads from "@/super_admin/HqServiceLeads";
import HqFinance from "@/super_admin/HqFinance";
import HqSocial from "@/super_admin/HqSocial";
import HqGiftPromo from "@/super_admin/HqGiftPromo";
import HqAi from "@/super_admin/HqAi";
import HqAutomation from "@/super_admin/HqAutomation";
import HqBlog from "@/super_admin/HqBlog";
import HqSiteManager from "@/super_admin/site/HqSiteManager";
import RevenueDashboard from "@/super_admin/RevenueDashboard";
import WebhooksMonitor from "@/super_admin/WebhooksMonitor";
import CustomDomainsManager from "@/super_admin/CustomDomainsManager";
import PaymentProvidersEditor from "@/super_admin/PaymentProvidersEditor";
import AffiliateManager from "@/super_admin/affiliate/AffiliateManager";
import ReviewsModeration from "@/super_admin/reviews/ReviewsModeration";
import PlatformCredentials from "@/super_admin/PlatformCredentials";
import GatewayConsole from "@/super_admin/GatewayConsole";

export const superAdminRoutes = (
  <>
    <Route path="/super-admin/login" element={<SuperAdminLogin />} />
    <Route path="/super-admin" element={<SuperAdminLayout />}>
      <Route index element={<SuperAdminOverview />} />
      <Route path="activity" element={<ActivityLog />} />
      <Route path="finance" element={<FinanceDashboard />} />
      <Route path="gateway" element={<GatewayConsole />} />
      <Route path="tenants" element={<TenantsList />} />
      <Route path="tenants/:tenant_id" element={<Tenant360 />} />
      <Route path="global" element={<GlobalDataView />} />
      <Route path="global/learn-telehealth" element={<GlobalLearnTelehealth />} />
      <Route path="plans" element={<PlansManager />} />
      <Route path="plan-features" element={<PlanFeatureMatrix />} />
      <Route path="catalog" element={<CatalogManager />} />
      <Route path="transactions" element={<TransactionsList />} />
      <Route path="client-transactions" element={<ClientTransactionsList />} />
      <Route path="team" element={<TeamManager />} />
      <Route path="audit" element={<AuditLogs />} />
      <Route path="integrations" element={<IntegrationsEditor />} />
      <Route path="webhooks" element={<WebhooksMonitor />} />
      <Route path="custom-domains" element={<CustomDomainsManager />} />
      <Route path="payments" element={<PaymentProvidersEditor />} />
      <Route path="platform-credentials" element={<PlatformCredentials />} />
      <Route path="revenue" element={<RevenueDashboard />} />
      <Route path="revenue/platform-revenue" element={<RevenueDashboard />} />
      <Route path="platform-revenue" element={<RevenueDashboard />} />
      <Route path="affiliate" element={<AffiliateManager />} />
      <Route path="reviews" element={<ReviewsModeration />} />
      <Route path="hq/customers" element={<HqCustomers />} />
      <Route path="hq/service-leads" element={<HqServiceLeads />} />
      <Route path="hq/finance" element={<HqFinance />} />
      <Route path="hq/social" element={<HqSocial />} />
      <Route path="hq/gift-promo" element={<HqGiftPromo />} />
      <Route path="hq/ai" element={<HqAi />} />
      <Route path="hq/automation" element={<HqAutomation />} />
      <Route path="hq/blog" element={<HqBlog />} />
      <Route path="hq/site" element={<HqSiteManager />} />
      <Route path="settings" element={<PlatformSettings />} />
    </Route>
  </>
);
